module.exports = __webpack_public_path__ + "img/4.da7bd222.png";